module.exports = __webpack_public_path__ + "img/no-snippet-light.66024cd.svg";